import React from "react";
import { SocialIcon } from "react-social-icons";

export default function Home() {
  return (
    <main>
      <section>
        <div className="home-container">
          <h1>hello!</h1>
          <h2>welcome to my space</h2>
        </div>

        <div className="home-icon-container">
          <SocialIcon
            url="https://github.com/PotatoPlan"
            target="_blank"
            bgColor="#FFFFFF"
            style={{ margin: 20 }}
          />

          <SocialIcon
            url="https://www.linkedin.com/in/zelinshu/"
            target="_blank"
            bgColor="#FFFFFF"
            style={{ margin: 20 }}
          />

          <SocialIcon
            url="https://twitter.com/ShuZelin98"
            target="_blank"
            bgColor="#FFFFFF"
            style={{ margin: 20 }}
          />
        </div>
      </section>
    </main>
  );
}
